import React from 'react';

import withAppState from '../mobx/withAppState'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';

class PaymentConfirmation extends React.Component {
  
  render() {
    const facebookIcon = <FontAwesomeIcon icon={faFacebookF} />
    const TwitterIcon = <FontAwesomeIcon icon={faTwitter} />
    const InstagramIcon = <FontAwesomeIcon icon={faInstagram} />

    const { bill: bills } = this.props;
    const bill = bills && bills.length > 0 ? bills[0] : null;

    const { outstandingBalance } = bill;
    return (
      <div className="payment-confirmation-container-wrapper">
        <div className="payment-confirmation-container">
          <div className="bill-paid"><p>{outstandingBalance > 0 ? `${this.props.getCurrency().symbol + this.props.billTotalWhenPaying.toFixed(2)} has been paid towards your bill. There is ${this.props.getCurrency().symbol + outstandingBalance.toFixed(2)} remaining.` : 'Bill is paid in full, you are free to leave.'}</p></div>
          {(!!this.props.customer && !!this.props.customer.emailAddress) && <div className="reciept-sent"><p>A receipt has been sent to {this.props.customer.emailAddress}.</p></div>}
          <div className="thank-you"><p>Thank you for your visit.</p></div>
          {this.props.canSignup && !this.props.isRegistered && <div className="register-card">
            <button className="btn btn-primary btn-register-success"
              onClick={() => this.props.handleGoToRegister()}>
              <span>Sign up for exclusive news & rewards</span>
            </button>
          </div>}
          {outstandingBalance > 0 && <button className="btn btn-secondary btn-remaining" onClick={() => this.props.handleBackToBillsButton()}>See remaining bills</button>}
          <a className="btn btn-secondary pizza-express" 
            href={this.props.returnHref}
          >Return to {this.props.companyName}</a>
          
          {this.props.hasSocialLinks &&
            <div className="social-buttons">
              <span className="socialCta">
                <a target="_blank" rel="noopener noreferrer" href="https://www.twitter.com/pizzaexpress">{TwitterIcon}</a>
              </span>
              <span className="socialCta">
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/pizzaexpress">{facebookIcon}</a>
              </span>
              <span className="socialCta">
                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/pizzaexpress/">{InstagramIcon}</a>
              </span>
            </div>}
        </div>
      </div>
    );
  }
}

export default withAppState(PaymentConfirmation,
  {
    mobXProps: ({
      bill,
      billTotalWhenPaying,
      customer,
      isRegistered,
    }) => ({
      bill,
      billTotalWhenPaying,
      customer,
      isRegistered,
    }),
    mobXActions: ({ 
      getCurrency
    }) => ({
      getCurrency
    })
  }
);
